export enum ShareAccessLevel {
  Public = 'public',
  Private = 'private',
  TeamShared = 'team',
}

export enum AccessSwitchMode {
  Disabled = 'disabled',
  Hidden = 'hidden',
}

export type ExternalShareType = {
  id: string;
  label: string;
  iconUrl: string;
};

export type ExternalShareGroup = {
  id: string;
  titleKey: string;
  shares: ExternalShareType[];
};
